import React from 'react';
import { BookOpen, MapPin, Clock, ArrowUpRight } from 'lucide-react';

export default function Services() {
  const address = "6486 W 130th Street, Cleveland, OH 44130";
  const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;

  return (
    <div id="services" className="py-28 bg-white relative overflow-hidden">
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary-50/50 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-blue-50/50 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm font-semibold text-primary-600 uppercase tracking-wider">Worship With Us</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-4">Join Us for Service</h2>
          <div className="w-16 h-1 bg-gradient-to-r from-primary-500 to-blue-500 mx-auto rounded-full"></div>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative bg-gradient-to-br from-gray-50 to-white p-10 md:p-14 rounded-3xl border border-gray-100 shadow-card hover:shadow-card-hover transition-all duration-500">
            <div className="absolute top-6 right-6 w-20 h-20 bg-primary-50 rounded-full opacity-60" />
            <div className="absolute bottom-6 left-6 w-14 h-14 bg-blue-50 rounded-full opacity-60" />

            <div className="relative flex flex-col md:flex-row items-start md:items-center gap-10">
              <div className="flex-1">
                <div className="w-16 h-16 bg-gradient-to-br from-primary-600 to-blue-600 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-primary-600/20">
                  <BookOpen className="text-white" size={28} />
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-3">Sunday Service</h3>
                <div className="flex items-center gap-2 text-primary-600 font-semibold text-lg mb-4">
                  <Clock size={18} />
                  <span>Every Sunday at 1:30 PM EST</span>
                </div>
                <p className="text-gray-600 leading-relaxed text-lg">
                  Join us for inspiring worship, powerful messages, and a welcoming community of believers.
                </p>
              </div>

              <div className="md:border-l md:border-gray-200 md:pl-10">
                <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center mb-4">
                  <MapPin className="text-primary-600" size={24} />
                </div>
                <a
                  href={googleMapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group block"
                >
                  <p className="font-semibold text-gray-900 group-hover:text-primary-600 transition-colors flex items-center gap-1">
                    Get Directions
                    <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                  </p>
                  <p className="text-gray-500 mt-1">6486 W 130th Street</p>
                  <p className="text-gray-500">Cleveland, OH 44130</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
